export default function detrail(url = '') {
	return url.replace(/\/+$/, ''); // Removes one or more trailing slashes from URL
}
